import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseFilterCollapseService } from '../../../core';
import { DatepickerComponent } from '../../../shared';
import { tipoClienteInativo, tipoClienteNovo, tipoClientePreInativo, tipoClienteRevisao, tipoClienteTituloVencido, tipoEntrarEmContato, tipoTarefa, tipoVisitar } from '../tipo';
import { AtividadeFilter } from './atividade-filter';
import { AtividadeFilterTipoOption } from './atividade-filter-tipo-option';
import { visibilidadeMinhas } from './visibilidade';

@Component({
    selector: 'sgt-atividade-filter',
    templateUrl: './atividade-filter.component.html',
    styleUrls: ['./atividade-filter.component.less']
})
export class AtividadeFilterComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() filter: AtividadeFilter;
    isFilterInitializing = false;
    isFilterInitialized = false;

    @Input() isSetDefaultFilters = true;
    @Output() filterInitialized = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() filterCleaned = new EventEmitter<any>();

    @ViewChild('diaPrazoInicial') diaPrazoInicial: DatepickerComponent;

    /** Tipos */
    tipoEntrarEmContato = tipoEntrarEmContato;
    tipoVisitar = tipoVisitar;
    tipoTarefa = tipoTarefa;
    tipoClienteNovo = tipoClienteNovo;
    tipoClientePreInativo = tipoClientePreInativo;
    tipoClienteInativo = tipoClienteInativo;
    tipoClienteRevisao = tipoClienteRevisao;
    tipoClienteTituloVencido = tipoClienteTituloVencido;

    // Filter collapse
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';

    constructor(private baseFilterCollapseService: BaseFilterCollapseService) { }

    ngOnInit() {
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            if (this.filterCollapse) {
                jQuery(this.filterCollapse.nativeElement).css('display', 'none');
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Seta os filtros padrões que devem estar adicionados ao criar o filtro */
    private async setDefaultFilters() {
        this.filter.visibilidade = visibilidadeMinhas.id;
        this.filter.tipoOption = AtividadeFilterTipoOption.Required;
        this.filter.comTipoEntrarEmContato = true;
        this.filter.comTipoVisitar = true;
        this.filter.comTipoTarefa = true;
    }

    /** Inicializa o filtro */
    private async initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        // Filtros padrões
        if (this.isSetDefaultFilters) {
            await this.setDefaultFilters();
        }

        setTimeout(() => {
            this.isFilterInitializing = false;
            this.isFilterInitialized = true;
            this.filterInitialized.emit()
        }, 0);
    }

    onFilterChange() {
        this.filterChange.emit();
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        // Removendo os filtros
        this.baseFilterCollapseService.clear(this);

        this.close();
        this.setDefaultFilters();
        this.filterCleaned.emit();
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /*async goToEssaSemanaClick() {
        try {
            await this.goToEssaSemana();
            this.filterChange.emit();
        } catch (error) {
            //
        }
    }*/

    /** Vai para a semana do dia de hoje */
    /*goToEssaSemana(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.dateUtilshttpService.getIntervaloSemana(new Date(), true)
                .subscribe(
                    semanaAtual => {
                        if (semanaAtual) {
                            // this.filter.semanaAtual = semanaAtual;
                            // this.diaPrazoInicial?.writeValue(semanaAtual.primeiroDia.data);
                            this.filter.diaPrazoInicial = semanaAtual.primeiroDia.data;
                            this.filter.diaPrazoFinal = semanaAtual.ultimoDia.data;
                        } else {
                            // this.filter.semanaAtual = null;
                            this.filter.diaPrazoInicial = null;
                            this.filter.diaPrazoFinal = null;
                        }

                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Ocorreu um erro ao obter a semana atual', error);
                        reject(error);
                    }
                );
        });
    }*/

    /** Vai para a semana anterior */
    /*goToSemanaAnterior() {
        this.dateUtilshttpService.getIntervaloSemanaAnterior(this.filter.semanaAtual?.dataBase, true)
            .subscribe(
                entity => {
                    this.filter.semanaAtual = entity;
                    this.filterChange.emit();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Ocorreu um erro ao obter a semana anterior', error)
            );
    }*/

    /** Vai para a próxima semana */
    /*goToProximaSemana() {
        this.dateUtilshttpService.getIntervaloProximaSemana(this.filter.semanaAtual?.dataBase, true)
            .subscribe(
                entity => {
                    this.filter.semanaAtual = entity;
                    this.filterChange.emit();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Ocorreu um erro ao obter a próxima semana', error)
            );
    }*/

    /** Ao alterar a opção de visibilidade das atividades */
    onChangeVisibilidade(visibilidade: number) {
        this.filter.visibilidade = visibilidade;
        this.filterChange.emit();
    }

    /** Ao alterar os usuários de destino */
    onChangeUsuariosDestino(idsUsuariosDestino: number[]) {
        this.filter.idsUsuariosDestino = idsUsuariosDestino;
        this.filterChange.emit();
    }
}
